import { useState, useEffect } from "react";
import { compartirImagen } from "../lib/comprobante";
import { ShareIcon } from "./Iconos";

const MENSAJES = {
  compartido: "Compartido",
  copiado: "Copiado, péguelo en WhatsApp",
  descargado: "Imagen descargada",
};

/**
 * Genera el comprobante y lo comparte.
 *
 * El texto del botón cuenta qué pasó, porque no es lo mismo en el
 * celular que en la computadora: en uno se abre WhatsApp y en el otro la
 * imagen queda en el portapapeles.
 *
 * @param {Function} generar   Devuelve una promesa con la imagen (Blob)
 * @param {string}   archivo   Nombre del archivo
 * @param {string}   etiqueta  Texto del botón
 */
const BotonCompartir = ({ generar, archivo, etiqueta = "Compartir", titulo }) => {
  const [estado, setEstado] = useState(null);
  const [trabajando, setTrabajando] = useState(false);

  // El mensaje de confirmación se borra solo.
  useEffect(() => {
    if (!estado) return;
    const temporizador = setTimeout(() => setEstado(null), 4000);
    return () => clearTimeout(temporizador);
  }, [estado]);

  const compartir = async () => {
    if (trabajando) return;
    setTrabajando(true);
    try {
      const imagen = await generar();
      const resultado = await compartirImagen(imagen, archivo, titulo || etiqueta);
      if (resultado !== "cancelado") setEstado(resultado);
    } catch (error) {
      alert("No se pudo generar la imagen.");
    } finally {
      setTrabajando(false);
    }
  };

  return (
    <button
      type="button"
      className={`btn-compartir ${estado ? "listo" : ""}`}
      onClick={compartir}
      disabled={trabajando}
    >
      <ShareIcon />
      {trabajando ? "Generando..." : estado ? MENSAJES[estado] : etiqueta}
    </button>
  );
};

export default BotonCompartir;
